import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;

    const match = window.location.hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    (async () => {
      if (!sessionId) {
        navigate("/");
        return;
      }
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        setUser(data);
        window.history.replaceState(null, "", "/studio");
        navigate("/studio", { state: { user: data } });
      } catch (e) {
        toast.error(e?.response?.data?.detail || "Login failed");
        navigate("/");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="grain min-h-screen flex items-center justify-center bg-[#0b0c10]" data-testid="auth-callback">
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="h-8 w-8 animate-spin text-[#00e5ff]" />
        <p className="overline">Signing you in</p>
      </div>
    </div>
  );
}
